// extracted by mini-css-extract-plugin
module.exports = {"stickyWrapper":"styles_stickyWrapper__2l7wC","hiddenStickyWrapper":"styles_hiddenStickyWrapper__253yO","content":"styles_content__s0kIN","button":"styles_button__iHQxL"};